import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    const patternStr = this.data.get("pattern") || "^\\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}\\b$"
    this.pattern = new RegExp(patternStr, "i")
    this.errorMessage = this.data.get("message")
  }

  validate(event) {
    for (const field of this._visibleFields()) {
      const value = field.value.trim()
      const requiredSelector = field.getAttribute("data-email-validation-required-when")

      if (requiredSelector) {
        const triggers = document.querySelectorAll(requiredSelector)
        const anyFilled = Array.from(triggers).some(el => el.value.trim() !== "")

        if (anyFilled && value === "") {
          this._prevent(event, field.getAttribute("data-email-validation-required-message"))
          return
        }
        if (anyFilled && !this.pattern.test(value)) {
          this._prevent(event, this.errorMessage)
          return
        }
        continue
      }

      if (value !== "" && !this.pattern.test(value)) {
        this._prevent(event, this.errorMessage)
        return
      }
    }
  }

  _prevent(event, message) {
    event.preventDefault()
    event.stopPropagation()
    alert(message)

    const form = event.target.closest ? event.target.closest("form") : event.target
    if (!form) return

    const btn = form.querySelector("[data-disable-with]") || form.querySelector("[type=submit]")
    if (btn) {
      btn.disabled = false
      if (window.Rails) window.Rails.enableElement(btn)
    }
  }

  _visibleFields() {
    return this.fieldTargets.filter(el => {
      const hidden = el.closest('[style*="display:none"], [style*="display: none"]')
      return !hidden
    })
  }
}
